import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './polyfill';
import React from 'react';
import { render } from 'react-dom';
import { ConnectedRouter } from 'react-router-redux';
import { Provider } from 'react-redux';
import { configure, history } from './store';
import Debounced from './services/Debounced';
import { rootSelector, rootComponent } from './config/mount';

const store = configure();
const notifyResize = () => { store.dispatch({ type: 'SCREEN_RESIZE' }); };

const root = document.getElementById(rootSelector());
notifyResize(); setTimeout(notifyResize, 1000); // first start could be slow
if (root) {
  const Root = () => (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        {rootComponent()}
      </ConnectedRouter>
    </Provider>
  );
	render(<Root />, root);
}

window.addEventListener('resize', () => { Debounced.start('resize', notifyResize, 250);	});
history.listen(() => {
  Debounced.start('resize', notifyResize, 250);
});



// WEBPACK FOOTER //
// ./src/index.js